import React from 'react'
import { HeaderVariants } from '@grammarly/badger-ui'

interface FeatureHighlightContextValue {
  titleStyle: HeaderVariants
}

const FeatureHighlightContext = React.createContext<FeatureHighlightContextValue>({
  titleStyle: 'T1',
})

export const FeatureHighlightProvider = FeatureHighlightContext.Provider

export const useFeatureHighlightContext = () => React.useContext(FeatureHighlightContext)
